import { useEffect, useState } from "react";
import { getTrocsRequestsList } from "../../services/callAPI/trocsRequests";
import { ITrocRequestTraveler } from "../../services/interfaces/ITrocResident2";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import TrocsRequestsTable from "../../components/tables/TrocsRequestsTable";

export function TrocsRequestsPage() {
  const [selectedOption, setSelectedOption] = useState<string>("TOUTES");

  const [isLoading, setIsLoading] = useState<boolean | null>(null);

  function handlePickUpSelectedOption(e: React.ChangeEvent<HTMLSelectElement>) {
    const selectedValue = e.target.value;

    setSelectedOption(selectedValue);
  }

  const [trocsRequestsList, setTrocsRequestsList] = useState<ITrocRequestTraveler[] | null>(null);

  const [trigUseEffect, setTrigUseEffect] = useState<boolean>(false);

  const [errorOccurred, setErrorOccurred] = useState(false);

  useEffect(() => {

    const pickUpTrocsRequests = async () => {
      try {
        setIsLoading(true); //start spinner

        //call API
        const response = await getTrocsRequestsList();

        if (response.status === 204) {
          setTrocsRequestsList(null);
        }
        else if (response.status === 200) {
          setTrocsRequestsList(response.data);
        }
        else {
          throw new Error("Erreur lors de la récupération des demandes de trocs");
        }

      }
      catch (error) {
        setIsLoading(false);
        //afficher un composant d'erreur au user
        setErrorOccurred(true);
      }
      finally {
        setIsLoading(false);
      }
    }

    pickUpTrocsRequests();

  }, [trigUseEffect]);

  if (isLoading) {
    return <SpinnerC />
  }
  else if (trocsRequestsList !== null && trocsRequestsList?.length > 0) {
    return (
      <>
        <section className="flex flex-col gap-2 pb-24">

          <h1 className="text-greenCustom font-bold">LISTE DES DEMANDES DE TROCS</h1>

          <div className="flex justify-end">

            <label htmlFor="dpd dpd-trocs-requests"></label>

            <select id="dpd dpd -trocs-requests" name="dropdown" className="border-2 border-greenCustom rounded-md p-2 text-greenCustom cursor-pointer" onChange={handlePickUpSelectedOption}>
              <option value={"TOUTES"}>Toutes</option>
              <option value={"EN_ATTENTE"} >En attente</option>
              <option value={"ACCEPTEE"}>Acceptée</option>
              <option value={"EFFECTUEE"}>Effectué</option>
            </select>
          </div>

          <TrocsRequestsTable selectedOption={selectedOption} trocsRequestsList={trocsRequestsList} setTrigUseEffect={setTrigUseEffect} />

        </section>
      </>
    )
  }
  else if (errorOccurred) {
    return <ErrorOccurred />
  }
  else {
    return (
      <div className="px-4 flex items-center justify-center text-center h-full">
        <p className="leading-loose">
          Tu n'as fait aucune demande de troc pour le moment !<br />
          Commence par créer un élément d'échange à troquer.<br />
          Ensuite recherche des trocs pour faire des demandes.
        </p>
      </div>
    )
  }
}